module.exports = __webpack_public_path__ + "img/智慧碳汇.a01f1b53.png";